const COMPONENT_NAME = "AnnouncementBanner";
export {
  COMPONENT_NAME
};
